import { CarMaintenanceFilterAndSearch } from "./CarMaintenanceFilterAndSearch";
import Box from "@mui/material/Box";
import React, { useState, useContext } from "react";
import FileSaver from "file-saver";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Stack from "@mui/material/Stack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { maintenanceCarActions } from "../../service/maintenancecar.actions";
import "./../genericModels.css";
import "./carMaintenanceStyle.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AddEditModalMaintenanceCar } from "./AddEditModalMaintenanceCar";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { Card, IconButton } from "@mui/material";
import EmptyState from "../../../../util/component/EmptyState";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import { useHasScope } from "../../../../config/globalConfig";
import EmptyStateGrid from "../common/EmptyStateGrid";
import AgGridOperationTable from "../common/AgGridOperationTable";

dayjs.extend(utc);

export const CarMaintenanceTable = () => {
  const hasScope = useHasScope;
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [
    dataFormSearchFieldForCarMaintenance,
    setDataFormSearchFieldForCarMaintenance,
  ] = useState<any>({
    plate: "",
    vin: "",
  });
  const { tenant } = useContext(ContextOperation);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [length, setLength] = useState<number>(0);
  const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
  const [getIdForDelete, setGetIdForDelete] = useState<any>({});
  const [pageState, setPageState] = useState<any>({
    data: [],
    vehicleId: -1,
  });
  const [maintenance, setMaintenance] = useState<any>({
    kmMaintenance: "",
    // maintenancePeriod: "",
    maintenanceDate: null,
  });
  const userMaintenanceCar = maintenanceCarActions();
  const { t } = useTranslation(["operation"]);
  const fieldFunction = () => {
    if (
      hasScope("SCOPE_UPDATE_MDVEHICLE_SERVICE")
    )
      return "_actions";
    else return "";
  };
  const columnDefs: any[] = [
    {
      field: "maintenanceDate",
      headerName: t("carMaintenance.maintenanceDate"),
      flex: 1,
      cellRenderer: (cellValues: any) => maintenanceDateColumn(cellValues),
    },
    {
      field: "kmMaintenance",
      headerName: t("carMaintenance.maintenanceKM"),
      flex: 1,
    },

    {
      field: fieldFunction(),
      headerName: '',
      sortable: false,
      flex: 0.7,
      maxWidth:80,
      cellStyle: {
        display: 'flex',
        alignItems: 'center'
      },
      cellRenderer: (params: any) => {
        const onClick = () => {
          setOpen(true);
          setGetIdForDelete(params);
        };
        return (
          <>
            {pageState.data.length > 0 && (
              <>
                {hasScope("SCOPE_UPDATE_MDVEHICLE_SERVICE") && (
                  <>
                    {pageState.data[0].id === params.data.id ? (
                      <Stack
                        direction="row"
                        height={"inherit"}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Tooltip title={t("tooltipTitle.editShowAction")}>
                          <EditIcon
                            style={{
                              color: "#C8017D",
                              // fontSize: "14px",
                            }}
                            onClick={() => editMaintenanceCar(params.data)}
                          />
                        </Tooltip>
                      </Stack>
                    ) : (
                      <Stack
                        direction="row"
                        height={"inherit"}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Tooltip title={t("tooltipTitle.editShowAction")}>
                          <EditIcon
                            style={{
                              color: "rgba(208, 208, 206, 1)",
                              // fontSize: "14px",
                            }}
                          />
                        </Tooltip>
                      </Stack>
                    )}
                  </>
                )}
              </>
            )}
          </>
        );
      },
    },
  ];

  const resetFormTextForSelectedCarMaintenance = () => {
    setDataFormSearchFieldForCarMaintenance({
      plate: "",
      vin: "",
    });
    setLength(0);
    setPageState({ data: [], vehicleId: -1 });
  };

  const exportDataByVehicleIdMaintenanceCar = () => {
    if (pageState.vehicleId === -1) {
      setOpen(true);
    } else {
      setIsLoading(true);
      userMaintenanceCar
        .exportFileMaintenanceCarDataById(tenant, pageState.vehicleId)
        .then((response: any) => {
          setIsLoading(false);
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          FileSaver.saveAs(blob, filename);
        });
    }
  };

  const SearchMaintenanceCar = () => {
    let plate = !!dataFormSearchFieldForCarMaintenance.plate
      ? dataFormSearchFieldForCarMaintenance.plate.trim()
      : null;
    let vin = !!dataFormSearchFieldForCarMaintenance.vin
      ? dataFormSearchFieldForCarMaintenance.vin.trim()
      : null;
    setIsLoading(true);
    userMaintenanceCar
      .getMaintenanceCar(tenant, plate, vin)
      .then((response: any) => {
        setPageState({
          data: manageData(response),
          vehicleId: response.data.vehicleId,
        });
        console.log("response", response);

        setLength(response.data.maintenances.length);

        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          setOpen(true);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        } else {
        }
        setIsLoading(false);
      });
  };

  const createEditMaintenanceCar = (valuesMaintenanceObject: any) => {
    if (valuesMaintenanceObject.editId) {
      userMaintenanceCar
        .updateMaintenanceCar(
          tenant,
          valuesMaintenanceObject.editId,
          valuesMaintenanceObject
        )
        .then((res) => {
          SearchMaintenanceCar();
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("carMaintenance.editActionSuccessMessage"),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });
        })
        .catch((error) => {
          if (error.response.status === 409) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t("carMaintenance.editActionErrorMessage"),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          }
        });
    } else {
      userMaintenanceCar
        .createMaintenanceCar(tenant, {
          ...valuesMaintenanceObject,
          vehicleId: pageState.vehicleId,
        })
        .then((res) => {
          SearchMaintenanceCar();
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("carMaintenance.createActionSuccessMessage"),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });
        })
        .catch((error) => {
          if (error.response.status === 409) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t("carMaintenance.createActionErrorMessage"),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          } else {
            setIsLoading(false);
          }
        });
    }
    setMaintenance({
      kmMaintenance: "",
      // maintenancePeriod: "",
      maintenanceDate: null,
    });
  };

  function manageData(response: any) {
    if (response !== undefined) {
      let rows: any[] = [];
      response.data.maintenances.forEach((element: any) => {
        let row = {
          maintenanceDate: element.maintenanceDate,
          kmMaintenance: element.kmMaintenance,
          // maintenancePeriod: element.maintenancePeriod,
          id: element.id,
        };
        rows.push(row);
      });
      return rows;
    }
  }

  const editMaintenanceCar = (params: any) => {
    setMaintenance({
      kmMaintenance: params.kmMaintenance,
      // maintenancePeriod: params.maintenancePeriod,
      maintenanceDate: params.maintenanceDate,
      editId: params.id,
    });
    setOpenAddDialog(true);
  };

  const onClickDelete = () => {
    setOpen(false);
  };

  const onClickCloseDialog = () => setOpen(false);
  const onClickAddDialog = () => {
    setOpenAddDialog(true);
  };
  const maintenanceDateColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.maintenanceDate ? (
          <Box width="inherit" height="inherit" component="span">
            {dayjs(`${cellValues.data.maintenanceDate}`).format(
              "DD/MM/YYYY-HH:mm"
            )}
          </Box>
        ) : (
          <Box></Box>
        )}
      </>
    );
  };

  const MyCustomNoRowsOverlay = () => (
    <EmptyState
      title={t("carMaintenance.noVehicleSelected")}
      content={t("carMaintenance.enterPlateOrVin")}
    />
  );

  const NoMaintenance = () => (
    <EmptyState
      title={t("carMaintenance.noMaintenanceRow")}
      content={t("carMaintenance.addNewRecord")}
    />
  );

  return (
    <>
      <SectionHeader
        title={
          t("carMaintenance.mainTitle.titleFirst") +
          " " +
          t("carMaintenance.mainTitle.titleSecond")
        }
      />
      <CarMaintenanceFilterAndSearch
        dataFormSearchFieldForCarMaintenance={
          dataFormSearchFieldForCarMaintenance
        }
        setDataFormSearchFieldForCarMaintenance={
          setDataFormSearchFieldForCarMaintenance
        }
        SearchMaintenanceCar={SearchMaintenanceCar}
        resetFormTextForSelectedCarMaintenance={
          resetFormTextForSelectedCarMaintenance
        }
      />
      <Box className="carGenericOuterTableBox">
        <Box className="carGenericTable">
          {/* <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick={exportDataByVehicleIdMaintenanceCar}>
                <FileDownloadIcon/>
               </IconButton>
          </Box>
         
        
        </Card>
        </Box> */}
          <Box>
            <Card>
              <Box
                minHeight={46}
                pr={1}
                display="flex"
                justifyContent={"flex-end"}
                alignItems="center"
              >
                <Tooltip title={t("tooltipTitle.download")}>
                  <IconButton
                    color="accent"
                    disabled={length === 0 ? true : false}
                    onClick={exportDataByVehicleIdMaintenanceCar}
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>

                {hasScope("SCOPE_CREATE_MDVEHICLE_SERVICE") && (
                  <Tooltip title={t("tooltipTitle.add")}>
                    <IconButton
                      color="accent"
                      onClick={onClickAddDialog}
                      disabled={pageState.vehicleId === -1}
                    >
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Card>
          </Box>
          <Box>
            {pageState.vehicleId !== -1 ? (
              <Box>
                <Box component="div">
                  <Box className="heightForNoImage">
                    <AgGridOperationTable
                      columnDefs={columnDefs}
                      rowData={pageState.data}
                      totalElements={pageState?.data?.length}
					  rowModelType="clientSide"
                    />


                  </Box>
                </Box>
              </Box>
            ) : (
              <Box component="div">
                <Box component="div" className="heightForNoImage">
                  <AgGridOperationTable
                    columnDefs={columnDefs}
                    rowData={pageState.data}
                    totalElements={pageState?.data?.length}
					rowModelType="clientSide"
                  />

                </Box>
              </Box>
            )}
          </Box>
          {loading && <CustomLoader loading={loading} />}
        </Box>
        <Dialog
          open={open}
          PaperProps={{
            sx: {
              minWidth: "800px !important",
              minHeight: "216px",
              borderRadius: "4px",
            },
          }}
        >
          <DialogTitle>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              <Grid xs item>
                <Stack direction="row" spacing={2} justifyContent="flex-start">
                  <ReportProblemIcon
                    style={{
                      width: "16px",
                      color: "#E20B0B",
                    }}
                  />
                  <span className="ReportProblemTitle">
                    {t("carMaintenance.wrongPlateOrVin")}
                  </span>
                </Stack>
              </Grid>
              <Grid
                xs
                item
                sx={{
                  justifyContent: "flex-end",
                  display: "flex",
                }}
              >
                <CloseIcon
                  color="disabled"
                  fontSize="small"
                  onClick={onClickCloseDialog}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent>
            <DialogContentText>
              {/* <Stack
                component={"span"}
                spacing={0.5}
                className="ReportProblemBody"
              > */}
                <Typography variant="bodySmall">{t("carMaintenance.incorrectVehicle")}</Typography>
                <br />
                <Typography variant="bodySmall">{t("carMaintenance.insertCorrectVehicle")}</Typography>
              {/* </Stack> */}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ background: "#F8F8F8" }}>
            <Stack direction="row" spacing={2} p={1} mr={1}>
              <Button
                sx={{
                  maxWidth: "111px",
                  maxHeight: "48px",
                  minWidth: "111px",
                  minHeight: "48px",
                }}
                variant="contained"
                color="accent"
                onClick={onClickDelete}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "white",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.close")}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Box>
      <Box>
        {openAddDialog && (
          <AddEditModalMaintenanceCar
            openAddDialog={openAddDialog}
            setOpenAddDialog={setOpenAddDialog}
            createEditMaintenanceCar={createEditMaintenanceCar}
            maintenance={maintenance}
            setMaintenance={setMaintenance}
            pageState={pageState.data}
          />
        )}
      </Box>
    </>
  );
};
